import React from 'react';

export default function PointReference({ isAuthenticated }) {
  return (
    <>
      <div style={{ display: isAuthenticated ? '' : 'none' }}>
        <p>Here are a few ways you can spend your points individually:</p>
        <ul>
            <li>1 = have a pop</li>
            <li>7 = get a bag of treats from the store</li>
            <li>15 = 2 Large Orders of French Fries</li>
            <li>20 = get 1000 v-bucks</li>
            <li>30 = get 3x your allowance</li>
        </ul>
        <p>Here are a few ways you can spend your points together:</p>
        <ul>
            <li>5 points total = free pop day for all</li>
            <li>10 points total = Later Bedtime on weekend</li>
            <li>50 points total = Papa John's Delivery</li>
        </ul>
        <p><strong>Restaurant Visits</strong></p>
        <ul>
            <li>20 points per person = "Fast food": under $20 per person, fountain drinks, no tipping</li>
            <li>30 points per person = "Sit-downs": under $20 per person, no free refills, tipping</li>
            <li>40 points per person = "Fancier": over $20+ per person, no free refills, tipping</li>
            <li>More Expensive? # People x (Avg Cost + Tip) x 2 points per dollar</li>
        </ul>
      </div>
    </>
  );
}
